export default __webpack_public_path__ + "static/media/GoogleAnalytics.cd8e19e6.webp";